import { ConsumerConstants as Constants } from '../types'

const initialState = {
    consumers: [],
    total: 0,

};

export function consumerReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:            
            return {
                ...state,
                consumers: action?.payload?.consumers,
                total: action?.payload?.total,
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                consumers: [...state?.consumers, action?.payload?.consumer]
            }

        case Constants.UPDATE:            
            const index = state.consumers.findIndex(x => x.id ===  action?.payload?.consumer?.id)
            const newArray = [...state.consumers];
            if(index > -1)
                newArray[index] = action?.payload?.consumer
            return {
                ...state,
                consumers: newArray                
            }   

        case Constants.DELETE:
            return{
                ...state,
                consumers: state?.consumers?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id))                
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null
            }

        case Constants.CLEAR:
            return{
                ...state,
                total: 0,
                consumers: []
            }
        default:
            return state
    }
}